import { render, staticRenderFns } from "./FarmersReports.vue?vue&type=template&id=bb702fea&scoped=true"
import script from "./FarmersReports.vue?vue&type=script&lang=js"
export * from "./FarmersReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb702fea",
  null
  
)

export default component.exports